import { connect } from 'react-redux'
import { useIntl } from 'react-intl'
import { LuxTextInput, LuxSelect, Color } from '@lux/wardrobe-lib'
import { FormBase, SurveyTaskMainInfoForm } from '@models/new-activity-form'
import { FILTERS_REDUCER_NAMESPACE } from '@/app/redux/reducers/filters'
import './SurveyTaskProjectTitle.scss'
import { getAssignees } from '@/app/redux/actions/activity-execution'
import { useEffect } from 'react'
import { NEW_ACTIVITY_EXECUTION_NAMESPACE } from '@/app/redux/reducers/activity-execution'

export interface SurveyTaskProjectTitleProps extends FormBase<SurveyTaskMainInfoForm> {
    assigneesList: any[]
    getAssignees: (
        storeId: string,
        profileList?: string[],
        role?: { isApproval: boolean; code: string }
    ) => void
}

const SurveyTaskProjectTitle = ({
    form,
    departmentList,
    recipientList,
    assigneesList,
    getAssignees,
    onSetForm,
}: SurveyTaskProjectTitleProps) => {
    const componentClass = 'smart-new-activity-survey-task-main-info-project-title'
    const intl = useIntl()

    useEffect(() => {
        if (form.recipient.value?.length > 0) {
            getAssignees(form.storeId.value, null, { isApproval: false, code: form.recipient.value })
        }
    }, [form.recipient.value])

    return (
        <div className={componentClass}>
            <div className={`${componentClass}__row`}>
                <LuxTextInput
                    value={form.title.value}
                    onChangeCallback={(value) =>
                        onSetForm({ ...form, title: { ...form.title, value } })
                    }
                    mandatory={form.title.mandatory}
                    disabled={form.title.disabled}
                    label={intl.formatMessage({
                        id: 'modals.new.activity.section.main.info.project.title',
                        defaultMessage: 'Project title',
                    })}
                    placeholder={intl.formatMessage({
                        id: 'modals.new.activity.section.main.info.project.title.placeholder',
                        defaultMessage: 'Type here',
                    })}
                    style={{ backgroundColor: Color.WHITE }}
                />
                <LuxSelect
                    value={form.department.value}
                    onChangeCallback={(value) =>
                        onSetForm({ ...form, department: { ...form.department, value } })
                    }
                    mandatory={true}
                    disabled={form.department.disabled}
                    label={intl.formatMessage({
                        id: 'modals.new.activity.section.main.info.select.department',
                        defaultMessage: 'Select department',
                    })}
                    options={departmentList.map((department) => ({
                        ...department,
                        label: intl.formatMessage({
                            id: department.label,
                            defaultMessage: department.label.split('.').pop(),
                        }),
                    }))}
                    placeholder={intl.formatMessage({
                        id: 'modals.new.activity.section.main.info.select.department',
                        defaultMessage: 'Select department',
                    })}
                    additionalProps={{
                        appendTo: 'self',
                    }}
                />
            </div>
            <div className={`${componentClass}__row`}>
                <LuxSelect
                    value={form.recipient.value}
                    onChangeCallback={(value) =>
                        onSetForm({ ...form, recipient: { ...form.recipient, value } })
                    }
                    mandatory={true}
                    disabled={form.recipient.disabled}
                    label={intl.formatMessage({
                        id: 'modals.new.activity.section.main.info.select.recipient',
                        defaultMessage: 'Select recipiet',
                    })}
                    options={recipientList.map((recipient) => ({
                        ...recipient,
                        label: intl.formatMessage({
                            id: recipient.label,
                            defaultMessage: recipient.label.split('.').pop(),
                        }),
                    }))}
                    placeholder={intl.formatMessage({
                        id: 'modals.new.activity.section.main.info.select.recipient',
                        defaultMessage: 'Select recipient',
                    })}
                    additionalProps={{
                        appendTo: 'self',
                    }}
                />
                <LuxSelect
                    value={form.username.value}
                    onChangeCallback={(value) =>
                        onSetForm({ ...form, username: { ...form.username, value } })
                    }
                    mandatory={true}
                    disabled={form.username.disabled || !form.recipient.value?.length}
                    label={intl.formatMessage({
                        id: 'modals.new.activity.section.main.info.select.username',
                        defaultMessage: 'Select username',
                    })}
                    options={assigneesList
                        .sort((a, b) =>
                            (a.nickname ? a.nickname : a.lastname).toLowerCase() < (b.nickname ? b.nickname : b.lastname).toLowerCase() ? -1 : 1
                        )
                        .map((a) => ({
                            label: a.nickname ? a.nickname : `${a.firstname} ${a.lastname}`,
                            value: a?.userId,
                        }))}
                    placeholder={intl.formatMessage({
                        id: 'modals.new.activity.section.main.info.select.username',
                        defaultMessage: 'Select username',
                    })}
                    additionalProps={{
                        appendTo: 'self',
                    }}
                />
            </div>
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    departmentList: state[FILTERS_REDUCER_NAMESPACE].departmentList,
    recipientList: state[FILTERS_REDUCER_NAMESPACE].recipientList,
    assigneesList: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].assignees,
})

const mapDispatchToProps = (dispatch: any) => ({
    getAssignees: (
        storeId: string,
        profileList?: string[],
        role?: { isApproval: boolean; code: string }
    ) => {
        dispatch(getAssignees(storeId, profileList, role))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(SurveyTaskProjectTitle)
